import * as React from 'react';
import TopLayout from './top-layout';
import { DarkModeState } from "./theme-context"

export const wrapRootElement = ({ element, props }) =>
(
    <DarkModeState {...props}><TopLayout>{element}</TopLayout></DarkModeState>
);
